import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { ButtonModule } from './../../common/button/button.module';
import { MessageModule } from './../../common/message/message.module';
import { BulkSelectionMessagesComponent } from './bulk-selection-messages.component';

@NgModule({
  declarations: [BulkSelectionMessagesComponent],
  exports: [BulkSelectionMessagesComponent],
  imports: [MessageModule, CommonModule, I18nModule, ButtonModule],
})
export class BulkSelectionMessagesModule {}
export { BulkSelectionMessagesComponent } from './bulk-selection-messages.component';
